import * as settings from '../settings.js';
import { showWMSInfo } from '../wmsInfoPanel';
import { Styles } from '../classes/Styles';
import { colors } from '../state';
import { setCursor, showError } from '../helpers';
const styles = new Styles();
export function clearLineSearch({ ol, state }) {
  ol.layers.lineSearchLayer.destroyFeatures();
  ol.layers.lineSearchLayer.redraw();
  ol.layers.lineSearchLayer.setZIndex(2007);
  state.lineSearchActive = false;

  $('#totallineSearch').text('');
}
export function getLineSearch({ state, ol }) {
  state.lineSearchResults = [];
  var parser = new jsts.io.OpenLayersParser();
  var polyg = parser.read(state.lineSearchFeat);
  if (polyg.shell) {
    polyg = polyg.shell;
  }
  var buffpoly = polyg.buffer(state.lsrad || 1);
  var outpoly = parser.write(buffpoly);
  var linearRing = new OpenLayers.Geometry.LinearRing(outpoly.components[0].components);
  var lineString = new OpenLayers.Geometry.LineString(linearRing.components);
  var simp = 0.5;
  var newLineString = lineString.simplify(0.1);
  var ie = !!window.MSInputMethodContext && !!document.documentMode;
  var maxpoint = ie ? 30 : 50;
  while (newLineString.components.length > maxpoint) {
    simp += 0.1;
    newLineString = lineString.simplify(simp);
  }
  var newLinearRing = new OpenLayers.Geometry.LinearRing(newLineString.getVertices());
  var newPolygon = new OpenLayers.Geometry.Polygon(newLinearRing);
  var feat = new OpenLayers.Feature.Vector(newPolygon);
  var wkt = new OpenLayers.Format.WKT();
  state.lineSearchPoly = wkt.write(feat);
  var data = {
    poly: state.lineSearchPoly,
    buffer: 0,
  };
  var newStyle = {};
  //  var feat = state.lineSearchFeat;
  jQuery.extend(newStyle, styles.propertyStyle);
  feat.style = styles.augment(newStyle, colors.lineSearch, 2, 0);
  feat.type = 'property';
  feat.subtype = 'property';
  feat.style = newStyle;
  ol.layers.lineSearchLayer.addFeatures([feat]);
  state.lineSearchCenter = feat.geometry.getCentroid();
  callLineSearch({ data, state, ol });
}
export function callLineSearch({ data, state, ol }) {
  setTimeout(function () {
    $('#lineSearch-range').prop('disabled', true);
  }, 200);
  setCursor({ type: 'progress' });
  $('.loader').show();
  $.ajax({
    url: settings.baseURL + '/nodeservice/lsbudMembers',
    type: 'GET',
    dataType: 'json',
    crossDomain: true,
    success: res => {
      $.ajax({
        url: settings.baseURL + '/proxy/linesearch',
        type: 'POST',
        dataType: 'json',
        crossDomain: true,
        data: data,
        success: function (result) {
          $('.loader').hide();
          if (result.notificationAddtionalInfo) {
            const affected = result.notificationAddtionalInfo.map(m => m.CompanyName);
            const members = res.members.filter(m => !affected.includes(m));
            result.search_result = result.notificationAddtionalInfo;
            result.attributes = [
              {
                description:
                  'Known Affected Utilities are LSBUD Members who have registered assets within the vicinity of your search area.',
                companies: result.notificationAddtionalInfo
                  .map((o, idx) => {
                    let number = '';
                    if (o.ContactNo) {
                      if (o.ContactNo.match(/^01/)) {
                        number = `Tel: ${o.ContactNo.replace(/\s+/g, '').replace(/(\d{5})(\d{3})(\d)/, ' $1 $2 $3')}`;
                      } else {
                        number = `Tel: ${o.ContactNo.replace(/\s+/g, '').replace(/(\d{4})(\d{3})(\d)/, ' $1 $2 $3')}`;
                      }
                    }
                    return `${idx + 1} - ${o.CompanyName} - ${number}`;
                  })
                  .join('<br />'),
              },
              {
                description:
                  'Known Not Affected Utilities are LSBUD Members who do not have registered assets within the vicinity of your search area.',
                companies: members.join('<br />'),
              },
              {
                description:
                  'Non-LSBUD Members are utility providers that are not registered with LSBUD and may have assets in your search area.',
                companies: `BT (Tel: 0800 917 3993)<br />
                CenturyLink Communications UK Limited (Tel: 0208 731 4613)<br />
                CityFibre (Tel: 0333 1507 282)<br />
                Colt (Tel: 01227 768 427)<br />
                Energetics Electricity (Tel: 01698 404 646)<br />
                ENGIE (Tel: 01293 549 944)<br />
                GTC (Tel: 01359 240 363)<br />
                KPN (c/-Instalcom)<br />
                Mobile Broadband Network Limited (Tel: 01212 621 100)<br />
                Sky UK Limited (Tel: 0207 032 3234)<br />
                Sota<br />
                Thames Water (Tel: 0845 070 9145)<br />
                Utility assets Ltd<br />
                Verizon Business (Tel: 01293 611 736)<br />
                Virgin Media k (Tel: 0870 888 3116)<br />
                Vodafone (Tel: 01454 662 881)<br />
                Wokingham District Council (Structures) (Tel: 01189 746 000)<br />`,
              },
            ];
            if (result.search_result && result.search_result.length) {
              $('#totalLineSearch').text('(' + result.search_result.length + ')');
              setupLineSearch({ result, state, ol });
            } else $('#totalLineSearch').text('');
          } else {
            $('#totalLineSearch').text('');
            setTimeout(function () {
              $('#lineSearch-range').removeAttr('disabled');
            }, 200);
            if ($('#lineSearch-range')[0].value !== '75') {
              showError({
                state,
                title: '<center>No Utilities Results</center>',
                message:
                  '<p>No lineSearch applications found within the selected polygon</p><p>Increase the search buffer to reveal nearby lineSearch applications</p>',
              });
            } else {
              showError({
                state,
                title: '<center>No Utilities Results</center>',
                message:
                  '<p>Our data provider has not found any lineSearch applications within the search area.<p><p>To increase the search area, draw a new larger polygon using the "Draw Other" tool and use that area as the selected polygon.</p>',
              });
            }
          }
        },
        error: function () {
          $('.loader').hide();
          showError({ state, title: 'Warning', message: 'Unable to contact utilities service' });
        },
      });
    },
  });
}
export function setupLineSearch({ result, state, ol }) {
  setTimeout(function () {
    $('#lineSearch-range').removeAttr('disabled');
  }, 200);
  setCursor({ type: 'help' });
  $('#lineSearch-settings').show();
  var newStyle = {};
  jQuery.extend(newStyle, styles.defaultStyle);
  var point = new OpenLayers.Geometry.Point(
    result.ConfirmedLocation.split(' ')[0],
    result.ConfirmedLocation.split(' ')[1],
  );
  var feat = new OpenLayers.Feature.Vector(point, null, styles.augment(newStyle, colors.orange, 2, 1, colors.orange));
  feat.style.pointRadius = '12';
  feat.style.label = result.search_result.length.toString();
  feat.style.labelAlign = 'cm';
  feat.style.fontColor = '#000000';
  feat.style.fontSize = '10px';
  feat.style.fontFamily = 'Arial';
  feat.style.fontWeight = 'bold';
  feat.attributes = result.attributes;
  feat.style.strokeColor = colors.lineSearch;
  feat.style.strokeWidth = 1;
  ol.layers.lineSearchLayer.addFeatures([feat]);
  ol.layers.lineSearchLayer.redraw();
  state.lineSearchActive = false;

  // show WMSInfo Panel at location
  if (ol.points.marker2) ol.layers.vectorPin.destroyFeatures([ol.points.marker2]);
  showWMSInfo({ evt: { ...feat, xy: ol.map.getPixelFromLonLat({ lon: point.x, lat: point.y }) }, state, ol, settings });
  ol.layers.lineSearchLayer.setZIndex(2008);
}
